export default {"src":"/_next/static/media/hayat-world-map.6308a9c0.svg","height":225,"width":529,"blurWidth":0,"blurHeight":0};